"use strict";
exports.__esModule = true;
exports.APPLICANT = void 0;
var APPLICANT = {
    APPLICANT_TYPE: {
        PRIMARY: 'primary',
        SUPPORTING: 'supporting'
    },
    GENDER: {
        FEMALE: 'female',
        MALE: 'male',
        OTHER: 'other',
        UNSPECIFIED: 'unspecified'
    },
    MARITAL: {
        MARRIED: 'married',
        SINGLE: 'single',
        DIVORCED: 'divorced',
        SEPARATED: 'separated',
        WIDOWED: 'widowed'
    },
    RESIDENCY_STATUS: {
        PERMANENT_RESIDENT: 'permanent_resident',
        TEMPORARY_RESIDENT: 'temporary_resident',
        NONE_RESIDENT: 'none_resident'
    },
    RESIDENTIAL_STATUS: {
        RENTING: 'renting',
        LIVE_WITH_PARENTS: 'live_with_parents',
        SHARED: 'shared',
        OWNER_OCCUPIER: 'owner_occupier',
        OWNER_MORTGAGED: 'owner_mortgaged'
    },
    LIVING_ARRANGEMENT: {
        RENTING: 'renting',
        PARENTAL_HOME: 'parental_home',
        PUBLIC_HOUSING: 'public_housing',
        OWN_HOME_WITH_MORTGAGE: 'own_home_with_mortgage',
        OWN_HOME_MORTGAGE_FREE: 'own_home_mortgage_free',
        OTHER_LIVING_ARRANGEMENT: 'other_living_arrangement'
    },
    APPLICANT_SOURCE: {
        MYCRM: 'mycrm',
        BANKING: 'banking'
    }
};
exports.APPLICANT = APPLICANT;
